<template>
  <div>
    <a-row style="min-width: 1500px;min-height: 800px">
      <a-col span="6" class="params-form2">
        <div class="title">
          污染物分类
          <a-button v-if="belongFabu==='未发布'" @click="onAddBadClassifyModalOpen('1')" type="dashed" shape="circle" icon="plus"/>
        </div>
        <a-divider/>
        <div ref="produceTree" class="overflowDiv">
          <a-tree  :show-line="true" :show-icon="false" :tree-data="treeData" :title="{  title: 'title',  }"
                   :expandedKeys.sync="expandedKeys" :selectedKeys.sync="selectedKeys" @select="onSearchPage">
            <template slot="title" slot-scope="item">
              <p>
                <a-space>
                  <span style="display: inline-block;line-height: 16px;font-size: 14px;font-weight: 700;color: #7c7c7c">{{item.title}}</span>
                  <a-button  v-if="belongFabu==='未发布'" size="small" @click="onAddBadClassifyModalOpen(item.path)" type="link" icon="plus"/>
                  <a-button  v-if="belongFabu==='未发布'" size="small" @click="onDelBadClassifyItem(item.path)" type="link" icon="close"/>
                </a-space>
              </p>
            </template>
          </a-tree>
        </div>
      </a-col>

      <a-col span="17" class="params-form2">
        <div class="title">
          污染物详情
          <a-button type="primary" @click="lookIndex">返回</a-button>
        </div>
        <a-divider/>
        <div class="table">
          <div class="params-form">
            <a-form-model ref="searchForm" layout="inline" :model="formState">
              <!--④查询条件字段名+组件+提示文字+请输入提示文字-->
              <a-form-model-item label="CAS码" prop="cas">
                <div style="display: inline-block;width: 100px">
                <a-input v-model="formState.cas"></a-input>
                </div>
              </a-form-model-item>
              <a-form-model-item label="中文通用名称" prop="cn">
                <div style="display: inline-block;width: 100px">
                <a-input v-model="formState.cn"></a-input>
                </div>
              </a-form-model-item>
              <a-form-model-item label="英文通用名称" prop="en">
                <div style="display: inline-block;width: 100px">
                <a-input v-model="formState.en"></a-input>
                </div>
              </a-form-model-item>
              <!--<a-form-model-item label="所属类型" prop="path">-->
                <!--<div style="display: inline-block;width: 100px">-->
                <!--<a-input v-model="formState.path"></a-input>-->
                <!--</div>-->
              <!--</a-form-model-item>-->
              <a-form-model-item>
                <a-space>
                  <!--<a-button @click="onResetSearch">重置</a-button><a-divider dashed="true" type="vertical" />-->
                  <a-button type="primary" @click="onSearchPage">查询</a-button>
                </a-space>
              </a-form-model-item>
            </a-form-model>
          </div>
          <div class="table-content">
            <div>
              <div class="title" style="width: 350px;display: inline-block">
                污染物详情
                <div v-if="selectedRowCount" style="width: 150px;display: inline-block;line-height: 20px;color: darkorange">
                  共选择{{selectedRowCount}}条
                </div>
              </div>

              <div class="btn" style="width: calc(100% - 350px);display: inline-block;text-align: right">
                <a-space>
                  <a-button type="primary" @click="onAddStdBadItemModalOpen" >选择</a-button>
                  <a-divider dashed="true" type="vertical" />
                  <a-button type="primary" @click="onExportExcel" >导出excel</a-button>
                  <a-divider dashed="true" type="vertical" />
                  <a-button  v-if="belongFabu==='未发布'" type="danger" @click="onBatchDelete">批量删除</a-button>
                </a-space>
              </div>
            </div>


            <a-config-provider :locale="locale">
              <a-table
                      :data-source="dataSource"
                      :columns="columns"
                      :pagination="pagination"
                      :loading="loading"
                      row-key="id"
                      :row-selection="{
                        selectedRowKeys: selectedRowKeys,
                        onChange: onSelectChange,
                    }"
                      @change="onPageChange"
                      :scroll="{ y: 500 }"
              >
                <template slot="caozuo" slot-scope="text, record">
                  <a-button v-if="belongFabu==='未发布'" type="link" @click="onDelete(record)">删除</a-button>
                </template>
              </a-table>
            </a-config-provider>
          </div>
          <add-std-bad-item-modal v-if="addStdBadItemModalVisable" :visible.sync="addStdBadItemModalVisable"
                                  :param="addStdBadItemModalParam"
                                  @addBadItemModalClose="onAddStdBadItemModalClose"></add-std-bad-item-modal>

          <add-bad-classify-modal v-if="addBadClassifyModalVisable" :visible.sync="addBadClassifyModalVisable"
                                  :param="addBadClassifyModalParam"
                                  @addBadClassifyModalClose="onAddBadClassifyModalClose"></add-bad-classify-modal>
        </div>
      </a-col>
    </a-row>
  </div>

</template>

<script>
//分页查询接口  ①分页查询SQL
import {getStdBadClassifyPage as getPage} from '../../../api/api'
import {delStdBadRelSelected as delPage,searchBadItemTree,delStdBadClassifySelected} from '../../../api/api'
//各个字段  ③查询条件选择组件


import AddStdBadItemModal from './AddStdBadItemModal'
import AddBadClassifyModal from './AddBadClassifyModal'

import _ from 'lodash'
import ExportJsonExcel from "js-export-excel"
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
    //各个字段  ⑤查询条件选择组件
    components: {
        AddStdBadItemModal,AddBadClassifyModal
    },
    props: {
        stdId: {
            type: String,
            default: '',
        },
        publishStatus: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            locale: zhCN,
            belongId:0,
            treeData: [],
            expandedKeys: [],
            selectedKeys: [],
            formState: {
                //②查询条件字段名
                name: ''
            },
            params: {},
            // 表头
            columns: [
                {
                    title: "分类名称",
                    dataIndex: "name",
                    width: "150px",
                },
                {
                    title: "CAS",
                    dataIndex: "cas",
                    width: "100px",
                    ellipsis: true,
                },
                {
                    title: "中文名称",
                    dataIndex: "cn",
                    width: "100px",
                    ellipsis: true,
                },
                {
                    title: "英文名称",
                    dataIndex: "en",
                    width: "100px",
                    ellipsis: true,
                },
                {
                    title: "用途",
                    dataIndex: "useFor",
                    width: "100px",
                    ellipsis: true,
                },
                {
                    title: "",
                    dataIndex: "id",
                    width: "200px",
                    scopedSlots: {customRender: "caozuo"},
                },
            ],
            // 表格数据
            dataSource: [],
            // 选中的行
            selectedRowKeys: [],
            selectedRows: [],
            loading: false,
            // 分页器
            pagination: {
                total: 0,
                current: 1,
                pageSize: 5,
                pageSizeOptions: ["5", "15", "35", "45"],
                showSizeChanger: true,
                size: "small",
                showTotal: total => `共${total}条记录 `
            },
            addStdBadItemModalVisable: false,
            addStdBadItemModalBackChange: null,
            addStdBadItemModalParam: null,
            addBadClassifyModalVisable: false,
            addBadClassifyModalBackChange: null,
            addBadClassifyModalParam: null,
            classifyId:''
        };
    },
    mounted() {
        this.belongId=this.stdId;
        this.belongFabu=this.publishStatus;
        this.initTree();
        this.onSearchPage();
    },
    computed: {
        selectedRowCount() {
            return this.selectedRowKeys.length;
        }
    },
    methods: {
        initTree() {
            // alert(this.belongId)
            searchBadItemTree(this.belongId).then((result => {
                if (result.data && result.data.data) {
                    this.insertSlot(result.data.data);
                    if (this.expandedKeys && this.expandedKeys.length === 0) {
                        let expandKeys = [];
                        result.data.data.forEach(item => {
                            expandKeys.push(item.key);
                        });
                        this.expandedKeys = expandKeys;
                    }
                    this.treeData = result.data.data

                }
                else {
                    this.treeData = [];
                }

            })).catch(() => {
            });
        },
        insertSlot(list) {
            list.map(item => {
                if (item.hasOwnProperty('children') && item.children && item.children.length > 0) {
                    this.insertSlot(item.children);
                }
                item.scopedSlots = {title: 'title'};
                return item;
            })
        },
        // 查询
        onSearchPage() {

            this.selectedRowKeys = [];
            this.selectedRows = [];
            this.pagination.current = 1;
            if(!this.pagination.pageSize)
            {
                this.pagination.pageSize=5;
            }
            this.params = {
                pageSize: this.pagination.pageSize,
                current: this.pagination.current,
                ...this.formState,
            };
            if(this.selectedKeys&&this.selectedKeys.length)
            {
                this.params.path=this.selectedKeys[0];
            }
            else
            {
                this.params.path='';
            }
            this.params.belongId=this.belongId;
            this.getData(this.params);
        },
        //重置
        onResetSearch() {
            this.$refs.searchForm.resetFields();this.onSearchPage();
        },
        // 翻页
        onPageChange(pagination, filters, sorter) {
            this.pagination = pagination;
            this.params.pageSize = pagination.pageSize;
            this.params.current = pagination.current;
            this.getData(this.params);
        },
        // 请求接口查询数据
        getData(params) {
            this.loading = true;

            getPage(params).then(result => {
                this.pagination.total = result.data.data.total;
                this.pagination.current = result.data.data.current;
                this.pagination.pageSize = result.data.data.size;
                this.dataSource = result.data.data.records.map((item, index) => {
                    item.index = index + 1
                    return item
                });
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        // 复选框变化
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
            let removedItems = [];
            let addItems = [];
            this.selectedRows.forEach(oldSelectedItem => {
                if (!selectedRowKeys.includes(oldSelectedItem.id)) {
                    removedItems.push(oldSelectedItem);
                }
            });
            this.selectedRowKeys.forEach(newKey => {
                let find = false;
                this.selectedRows.forEach(oldSelectedItem => {
                    if (oldSelectedItem.id === newKey) {
                        find = true;
                    }
                });
                if (!find) {
                    this.dataSource.forEach(thisPageItem => {
                        if (thisPageItem.id === newKey) {
                            addItems.push(thisPageItem);
                        }
                    })
                }
            });
            removedItems.forEach(row => {
                this.selectedRows.remove(row)
            });
            this.selectedRows = this.selectedRows.concat(addItems)
        },
        onDelete(record) {
            if (this.selectedRowKeys.length === 0) {
                this.$message.error('请选择要删除的数据');
                return
            }
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    delPage(record.id).then(() => {
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        onAddBadClassifyModalOpen(ppath) {
            if (!ppath) {
                ppath = '1';
            }
            this.addBadClassifyModalParam = {belongId:this.belongId,ppath: ppath};
            this.addBadClassifyModalVisable = true;
            //TODO: 无
        },
        onDelBadClassifyItem(path)
        {
            let sucFun=this.success;
            let initTFun=this.initTree;
            let belongId=this.belongId;
            this.$confirm({
                title: '确定要删除吗?',
                content: '删除后数据无法恢复，请谨慎删除！',
                onOk() {
                    delStdBadClassifySelected({belongId:belongId,path:path}).then((result => {
                        if (result.data && result.data.data) {
                            sucFun();
                            initTFun();
                        }
                    }));
                },
                onCancel() {},
            });
        },
        onAddBadClassifyModalClose() {
            //TODO: 无
            this.initTree();
        },
        success(updateItem) {
            this.$message.success(
                '操作成功',
                2,
            );
        },
        onAddStdBadItemModalOpen() {
            if(this.selectedKeys&&this.selectedKeys.length) {
                this.caclClassifyId(this.treeData,this.selectedKeys[0]);
                if(this.classifyId) {
                    this.addStdBadItemModalParam = {classifyId: this.classifyId};
                    this.addStdBadItemModalVisable = true;
                }
            }
            else
            {
                alert('提醒必须选择一个树节点')
            }

        },
        caclClassifyId(list,key) {
            list.map(item => {
                if (item.hasOwnProperty('children') && item.children && item.children.length > 0) {
                    this.caclClassifyId(item.children,key);
                }
                if(item.key===key){
                    console.log(this.classifyId,key,item.key,item.id)
                    this.classifyId=item.id;
                }
                return item;
            })
        },
        onAddStdBadItemModalClose() {
            //TODO: 无
            this.params.belongId=this.belongId;
            this.getData(this.params);
        },

        onAddStdBadItemClick() {
            //TODO:弹出新增面板
        },
        // 批量删除
        onDelete(record) {
            let keys = [record.id];
            let funcOK = () => {
                delPage(_.join(keys, ',')).then(() => {
                    if(this.selectedRowKeys.indexOf(record.id)>-1){
                        this.selectedRowKeys.remove(record.id);
                        this.selectedRows.remove(record);
                    }

                    this.getData(this.params);
                }).catch(err => {
                    this.$message.error(err.message);
                });
            }
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    funcOK();
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        onBatchDelete() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.error('请选择要删除的数据');
                return
            }
            let keys = this.selectedRowKeys;
            let funcOK = () => {
                delPage(_.join(keys, ',')).then(() => {
                    this.selectedRowKeys = [];
                    this.selectedRows = [];
                    this.getData(this.params);
                }).catch(err => {
                    this.$message.error(err.message);
                });
            }
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    funcOK();
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        // 导出excel
        onExportExcel() {
            if (this.selectedRowKeys.length == 0) {
                this.$message.error('请选择要导出的数据');
                return
            }
            let sheetColHeader=[];
            let sheetColFilter=[];
            this.columns.forEach(col=>{
                if(col.title !== '操作'&&col.title !== '') {
                    sheetColFilter.push(col.dataIndex)
                    sheetColHeader.push(col.title)
                }
            });
            let exportRows=[];
            let i=0;
            this.selectedRows.forEach(item=>{
                i++;
                let newItem=_.cloneDeep(item);
                newItem.index=i.toString();
                exportRows.push(newItem)
            });
            let option = {};
            option.fileName = "污染物详情";
            option.datas = [
                {
                    sheetData: exportRows,
                    sheetName: "污染物详情",
                    sheetFilter: sheetColFilter,
                    sheetHeader: sheetColHeader,
                    columnWidths: [],
                },
            ];

            var toExcel = new ExportJsonExcel(option); //new
            toExcel.saveExcel();
        },
        lookIndex(record)
        {
            this.$emit('fanhui', null);
        }
    },
};
</script>
<style lang="scss" scoped>
  .params-form2 {
    margin: 10px;
    padding: 20px;
    height: calc(100vh - 200px);
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    box-shadow: #1b2f7017 0px 2px 4px 2px;
    min-height: 800px;
  }

  .title {
    padding-left: 12px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    color: rgba(0, 0, 0, 0.85);
    position: relative;
    margin-bottom: 16px;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
  }

  .title::before {
    content: '';
    position: absolute;
    height: 16px;
    top: calc(50% - 8px);
    left: 0px;
    width: 3px;
    background-color: rgb(36, 113, 210);
  }
  .table {
    .params-form {
      padding-top: 16px;
      padding-left: 20px;
      margin: 16px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      justify-content: space-between;
      border-radius: 8px;
      background-color: rgb(255, 255, 255);
      box-shadow: #1b2f7017 0px 2px 4px 2px;
    }
    .table-content {
      margin: 16px;
      padding: 20px 24px;
      box-shadow: #1b2f7017 0px 2px 4px 2px;
      background-color: rgb(255, 255, 255);
      border-radius: 8px;
      overflow-y: hidden;
      .title {
        padding-left: 12px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: rgba(0, 0, 0, 0.85);
        position: relative;
        margin-bottom: 16px;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
      }
      .title::before {
        content: '';
        position: absolute;
        height: 16px;
        top: calc(50% - 8px);
        left: 0px;
        width: 3px;
        background-color: rgb(36, 113, 210);
      }

      .btn {
        padding-bottom: 15px;
        display: flex;
        justify-content: end;
      }

      /deep/ .ant-table-wrapper {
        .ant-table {
          border-top: 1px solid rgba(15, 41, 61, 0.45);
          border-bottom: 1px solid rgba(15, 41, 61, 0.45);
          border-image: initial;
          border-left: none;
          border-right: none;
        }
        .ant-table-thead {
          background: #fafafa;
        }
        .ant-table-thead > tr > th {
          font-weight: 500;
          line-height: 1;
          color: rgba(21, 40, 77, 0.65);
          background-color: rgb(245, 250, 255);
        }
      }
    }
  }
</style>
